import axios from 'axios'
import Errors from './types/errors'
import enums from './enums'

const http = new axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

http.download = function(url, data, options) {
  if (!options) options = {
  };

  options.methods = options.method || 'get';

  return new Promise((resolve, reject) => {
    this.request({
      url,
      method: options.method,
      responseType: 'blob',
      headers: {
        'accept': '*/*'
      },
      ...data
    }).then((response) => {
      // in case of server error response contains the following data:
      // headers:
      //   content-type: "text/html"

      if (_.get(response.data, 'type') === 'application/json') {
        const reader = new FileReader();
        reader.onloadend = function (evt) {
          let error;

          if (evt.target.readyState == FileReader.DONE) { // DONE == 2
            const json = JSON.parse(evt.target.result);
            const {status, errorCode} = json;

            if (status !== 200) {
              error = new Errors(errorCode);
            }
          }

          reject(error);
        };
        reader.readAsText(response.data);
      } else {
        const blob = new Blob([response.data]);
        let filename = options.filename;

        resolve();

        const disposition = (response.headers['content-disposition'] || '').split(';');

        if (disposition[0] === 'attachment' && !filename) {
          const filenameParam = disposition.find(e => e.trim().indexOf('filename=') === 0);

          if (filenameParam) {
            filename = filenameParam.trim().split('=')[1];
          }
        }

        if (!filename) {
          filename = Date.now().toString();
        }

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      }
    })
      .catch((e) => reject(e));
  })
};

http.Number = {
  fromAPI: (value, def = undefined, empty = undefined) => value !== empty ? +value : def,
  toAPI: (value, def = undefined, empty = undefined) => value !== empty ? +value : def
};

http.Date = {
  fromAPI: (date, def = undefined) => date ? new Date(date) : def,
  toAPI: (date, def = undefined) => date ? +date : def
};

http.Enum = {
  fromAPI: (value, EnumClass, def = undefined) => new EnumClass(value || def),
  toAPI: (value, def = undefined) => value ? value.valueOf() : def
};

for (const key in enums)
{
  http[key] = enums[key];
}

export default http;
